var map = {
	"./360.json": "3883",
	"./apple.json": "46ed",
	"./asus.json": "c3cd",
	"./google.json": "b87e",
	"./honor.json": "93a4",
	"./huawei.json": "bf39",
	"./lenovo.json": "75ec",
	"./letv.json": "aa62",
	"./meizu.json": "3056",
	"./mitv.json": "5c21",
	"./motorola.json": "1715",
	"./nokia.json": "90dd",
	"./nubia.json": "80c1",
	"./oneplus.json": "2b8f",
	"./oppo.json": "1560",
	"./pc.json": "c404",
	"./realme.json": "b814",
	"./samsung.json": "11fe",
	"./smartisan.json": "fb05",
	"./sony.json": "4201",
	"./vivo.json": "0960",
	"./xiaomi.json": "276f",
	"./zhixuan.json": "d43f",
	"./zte.json": "2509"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f73d";